/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.partners.detail.membership.controllers', [
  'ui.router',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.calendar',
  'acme.common.service.userPreferences',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition'
])

.controller('PartnersDetailMembershipController', ['$scope', '$state', '$filter', 'ApiService', 'CalendarService', 'HelpersService', 'UserPreferencesService', 'GridStateFactory', 'GridDefinitionFactory', function($scope, $state, $filter, ApiService, CalendarService, HelpersService, UserPreferencesService, GridStateFactory, GridDefinitionFactory) {

    $scope.partnersDetailMembership = {

      model: {},
      cardholders: [],
      dateFormat: UserPreferencesService.getDateFormat('standardDate', 'dateFormat'),

      tab: 'cardholders',

      isLoaded: false,

      details: {
        columns: 4,
        data: 'partnersDetailMembership.model',
        include: [
          'organizationName',
          'program',
          'category',
          'subcategory',
          'importId',
          'membershipMethod',
          'membershipJoinedDate',
          'membershipStartDate',
          'membershipExpirationDate',
          'membershipStanding',
          'membershipCategory',
          'externalMembershipId',
          'acmeMembershipNumber',
          'isGift'
        ],
        filters: {
          membershipExpirationDate: function(value) {
            return $filter('date')(CalendarService.parseDate(value), $scope.partnersDetailMembership.dateFormat);
          },
          membershipStartDate: function(value) {
            return $filter('date')(CalendarService.parseDate(value), $scope.partnersDetailMembership.dateFormat);
          },
          membershipJoinedDate: function(value) {
            return $filter('date')(CalendarService.parseDate(value), $scope.partnersDetailMembership.dateFormat);
          },
          isGift: function(value) {
            return (value) ? 'Yes' : 'No';
          }
        }
      },

      cardholdersGridState: new GridStateFactory(),

      cardholdersGrid: {
        showFooter: true,
        multiSelect: false,
        enableRowSelection: false,
        paginate: true,
        pageSize: 10,
        columnDefs: [
          {
            field: 'externalMembershipId',
            displayName: 'External Membership Id',
            headerTooltip: true,
            visible: true,
            sort: {
              direction: 'asc'
            }
          },
          {
            field: 'membershipStanding',
            displayName: 'Membership Standing',
            headerTooltip: true,
            visible: true,
            sort: {
              direction: 'asc'
            }
          },
          {
            field: 'name',
            displayName: 'Name on Card',
            headerTooltip: true,
            visible: true
          },
          {
            field: 'firstName',
            displayName: 'First Name',
            headerTooltip: true,
            visible: true
          },
          {
            field: 'lastName',
            displayName: 'Last Name',
            headerTooltip: true,
            visible: true
          },
          {
            field: 'email',
            displayName: 'Email',
            headerTooltip: true,
            visible: true
          },
          {
            field: 'cardType',
            displayName: 'Card Type',
            headerTooltip: true,
            visible: true
          },
          {
            field: 'streetAddress1',
            displayName: 'Address',
            headerTooltip: true,
            visible: true
          },
          {
            field: 'city',
            displayName: 'City',
            headerTooltip: true,
            visible: true
          },
          {
            field: 'state',
            displayName: 'State',
            headerTooltip: true,
            visible: true
          },
          {
            field: 'zipCode',
            displayName: 'Zip',
            headerTooltip: true,
            visible: true
          },
          {
            field: 'membershipJoinedDateDisplay',
            displayName: 'Joined',
            headerTooltip: true,
            visible: true,
            cellFilter: 'date: "' + HelpersService.dateFormats.sortDate + '"',
            cellFormatter: function(item) {
              return $filter('date')(item.value, HelpersService.dateFormats.shortDateTime);
            }
          },
          {
            field: 'membershipExpirationDateDisplay',
            displayName: 'Expires',
            headerTooltip: true,
            visible: true,
            cellFilter: 'date: "' + HelpersService.dateFormats.sortDate + '"',
            cellFormatter: function(item) {
              return $filter('date')(item.value, HelpersService.dateFormats.shortDateTime);
            }
          },
          {
            field: 'barcode',
            displayName: 'External Barcode',
            headerTooltip: true,
            visible: false
          },
          {
            field: 'acmeBarcode',
            displayName: 'ACME Barcode',
            headerTooltip: true,
            visible: false
          },
          {
            field: 'acmeCustomerNumber',
            displayName: 'ACME Customer Number',
            headerTooltip: true,
            visible: false
          },
          {
            field: 'acmeMembershipNumber',
            displayName: 'ACME Membership Number',
            headerTooltip: true,
            visible: false
          },
          {
            field: 'constituentId',
            displayName: 'Constituent Id',
            headerTooltip: true,
            visible: false
          },
          {
            field: 'externalConstituentId',
            displayName: 'External Constituent Id',
            headerTooltip: true,
            visible: false
          },
          {
            field: 'deceased',
            displayName: 'Deceased',
            headerTooltip: true,
            visible: false
          },
          {
            field: 'printStatus',
            displayName: 'Print Status',
            headerTooltip: true,
            visible: false
          },
          {
            field: 'printCount',
            displayName: 'Print Count',
            headerTooltip: true,
            visible: false
          }
        ]
      },

      init: function() {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Organization Membership',
          buttonLeft: {
            label: 'Close',
            permissions: 'ACCT_VIEW',
            action: function() {
              $state.go('application.partners.detail', { id: $state.params.id });
            }
          }
        });

        this.cardholdersGridState.updateGridState(null, this.cardholdersGrid.pageSize, 'firstName');

        this.getPartnerMembership($state.params.membershipId);

      },

      getPartnerMembership: function(id) {
        ApiService.membership.detail(id).then(this.success.getPartnerMembership, this.error.getPartnerMembership);
      },

      isTab: function(tab) {
        return (this.tab === tab);
      },

      setTab: function(tab) {
        this.tab = tab;
      },

      hasCardholders: function() {
        return (this.cardholders instanceof Array && this.cardholders.length > 0);
      },

      success: {
        init: function(response) {},

        getPartnerMembership: function(response) {

          var self = $scope.partnersDetailMembership;

          self.model = response.data.payload;

          if (self.model.cardholders instanceof Array) {
            self.cardholders = self.model.cardholders;
            self.cardholdersGridState.setPropertyValue('totalItems', self.model.cardholders.length);
          }

          self.isLoaded = true;

        }

      },

      error: {
        init: function(response) {},
        getPartnerContacts: function(response) {}
      },

      onCardholdersGridDoubleClick: function(item) {
        $state.go('application.membership.detail.member', { id: item.entity.membershipId, memberId: item.entity.cardImportId });
      }

    };

    $scope.partnersDetailMembership.init();

}]);